import { type ReactNode } from 'react';

import { CrossIcon } from '@common/svg/icons/components/CrossIcon';

import styles from './Header.module.scss';

interface Props {
    title: ReactNode;
    icon?: ReactNode;
    closeModal: () => void;
    onCancel?: () => void;
}

export const Header = ({ title, icon, closeModal, onCancel }: Props) => {
    const onCloseModal = () => {
        if (onCancel) {
            onCancel();
        }
        closeModal();
    };
    return (
        <header className={`${styles.header} flex justify-between`}>
            <div className={styles['header-title']}>
                {icon ? <span className={styles['header-title-icon']}>{icon}</span> : null}
                <h2 className={styles['header-title-text']}>{title}</h2>
                <button
                    aria-label="Close"
                    className={styles['header-close-button']}
                    data-testid="modal-close-button"
                    onClick={onCloseModal}
                >
                    <CrossIcon />
                </button>
            </div>
        </header>
    );
};
